import { PlusButton } from "@components/buttons/plus";
import { SHStack } from "@components/design-systems";
import { FamilyMemberAccountDTO } from "@models/platform-analysis/entities/steps/fee";
import { Collapse, SxProps } from "@mui/material";
import { memo } from "react";
import { TransitionGroup } from "react-transition-group";
import { FamilyMemberAccountBalance } from "../accounts";

type Props = {
  memberIndex: number;
  title?: string;
  accounts?: FamilyMemberAccountDTO[];
  disabled?: boolean;
  maxAccountsReached?: boolean;
  boxStyles?: SxProps;
  onAdd?: () => void;
  onChange?: (accounts: FamilyMemberAccountDTO[]) => void;
  onRemove?: (accountId: string) => void;
};

export const CardBalancesBox = memo(
  ({
    memberIndex,
    title,
    accounts = [],
    disabled,
    maxAccountsReached,
    boxStyles,
    onAdd,
    onRemove,
  }: Props) => {
    return (
      <SHStack
        height={"100%"}
        alignItems={"center"}
        padding={2}
        spacing={accounts.length === 0 ? 0 : 2}
        sx={{ ...boxStyles }}
      >
        <TransitionGroup
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            width: "100%",
            flex: 1,
          }}
        >
          {accounts.map((item, index) => {
            return (
              <Collapse key={item.id}>
                <FamilyMemberAccountBalance
                  memberIndex={memberIndex}
                  account={item}
                  title={title}
                  disabled={disabled}
                  itemIndex={index}
                  onRemove={() => onRemove?.(item.id || "")}
                />
              </Collapse>
            );
          })}
        </TransitionGroup>

        <PlusButton
          disabled={disabled || maxAccountsReached}
          fullWidth={false}
          variant="outlined"
          size="medium"
          sx={{ width: "fit-content" }}
          onClick={onAdd}
        >
          {title}
        </PlusButton>
      </SHStack>
    );
  },
);
